<template>
	<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 53.4 60.1" style="enable-background:new 0 0 53.4 60.1;" xml:space="preserve" width="53.4" height="60.1">
		<path d="M47.8,0H5.6C2.5,0,0,2.5,0,5.6v42.2c0,3.1,2.5,5.6,5.6,5.6h42.2c3.1,0,5.6-2.5,5.6-5.6V5.6
			C53.4,2.5,50.9,0,47.8,0 M26.6,32.6c1.8,0,3.6-0.7,5.4-2.3l2.5,2.9c-2.6,2.1-5.6,3.3-8.6,3.3c-5.9,0-9.7-3.9-8.8-9.5
			S23,17.5,29,17.5c2.9,0,5.6,1.1,7.4,3.2l-3.5,2.9c-1-1.3-2.7-2.2-4.6-2.2c-3.6,0-6.3,2.3-6.9,5.6C21,30.2,23,32.6,26.6,32.6" fill="#E5422B"></path>
	</svg>
</template>

<script>
export default { name: 'craft' }
</script>